export default "__VITE_ASSET__xX7saT2M__"